import { render, staticRenderFns } from "./stayHouse.vue?vue&type=template&id=5501364a&scoped=true&"
import script from "./stayHouse.vue?vue&type=script&lang=js&"
export * from "./stayHouse.vue?vue&type=script&lang=js&"
import style0 from "./stayHouse.vue?vue&type=style&index=0&id=5501364a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5501364a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\mzkj\\要炼\\yl-pc-business\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5501364a')) {
      api.createRecord('5501364a', component.options)
    } else {
      api.reload('5501364a', component.options)
    }
    module.hot.accept("./stayHouse.vue?vue&type=template&id=5501364a&scoped=true&", function () {
      api.rerender('5501364a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/orderSearch/comp/stayHouse.vue"
export default component.exports